import { Portal } from '@radix-ui/react-tooltip';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

const TableTooltip = ({
  description,
  align = 'center',
  className,
  children,
}: {
  description: React.ReactNode;
  align?: 'center' | 'end' | 'start';
  className?: string;
  children: React.ReactNode;
}) => {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <Portal>
          {description && (
            <TooltipContent
              side='bottom'
              align={align}
              className={className}
            >
              {description}
            </TooltipContent>
          )}
        </Portal>
      </Tooltip>
    </TooltipProvider>
  );
};

export default TableTooltip;
